import { TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { capitaliseText } from "../../../helpers/StringHelpers"
import EmailValidator from "../../../services/validation/personal-and-contact-details-form/EmailValidator"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

function EmailInputField(props: FormFieldProps<string>) {
    const { t } = useTranslation(`signup`)
    const { handleChange, errorText, defaultValue, isDisabled } = props
    const [helperText, setHelperText] = useState(``)
    const [error, setError] = useState(false)

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        validateField(capitaliseText(event.target.value))
        handleChange(capitaliseText(event.target.value))
    }

    const validateField = (value: string) => {
        const validationText = (new EmailValidator()).validate(value)
        setHelperText(validationText ?? ``)
        setError(validationText !== undefined)
    }

    useEffect(() => {
        setError(errorText !== undefined)
        setHelperText(errorText ?? ``)
    }, [errorText])

    return (
        <TextField
            id="email-input"
            fullWidth
            label={t(`email`)}
            variant="outlined"
            margin="normal"
            value={defaultValue}
            error={error}
            helperText={t(helperText)}
            onChange={handleOnChange}
            onBlur={handleOnChange}
            type="email"
            inputProps={{ style: { textTransform: `uppercase` } }}
            disabled={isDisabled}
        />
    )
}

export default EmailInputField